/**
 * Footer policy links inside Horizon's hover popover can lose the click:
 * popover="auto" light-dismisses on pointerdown, so the navigation never fires.
 * Force a full-page visit when a policy link is pressed.
 */
(() => {
  const isPolicyLink = (element) => {
    if (!(element instanceof Element)) return null;
    return element.closest(
      "[data-vow-policy-link], #terms-policies-popover a, .policy_list a",
    );
  };

  document.addEventListener(
    "pointerdown",
    (event) => {
      const link = isPolicyLink(event.target);
      if (!(link instanceof HTMLAnchorElement) || !link.href) return;
      event.preventDefault();
      event.stopPropagation();
      window.location.assign(link.href);
    },
    true,
  );
})();
